import { createAction, props } from '@ngrx/store';

export const updateChartColors = createAction(
  '[Calculator] Update Chart Colors',
  props<{
    payload: {
      colors: string[];
    };
  }>()
);
